/**
 * @file utils/bizUtil.js 一些业务快捷工具
 * @author chenbo09
 */

import _, {Dictionary} from 'lodash';
import {toast} from 'acud';

function isValid(item: any): boolean {
    return ['', undefined, null].includes(item);
}

export function getErrorMessage(error: any = {}, defaultMessage: string): string {
    let res;
    if (error !== null) {
        res = error instanceof Error ? error.message : error.global;
    }
    return res || defaultMessage;
}

export function getGlobalError(error: any = {}): string {
    return (error && error.global) || '';
}

export function filterData<T>(data: Dictionary<T> | null | undefined, predicate: any = isValid): Dictionary<T> {
    return _.omitBy(data, predicate);
}

export function message(type: string, msg: string): void {
    toast[type]({
        message: msg,
        duration: 3
    });
}

export function isValue(val: any) {
    return !(_.isNaN(val) || _.isNull(val) || _.isUndefined(val));
};